import { useEffect, useState } from "react";

export default function PrivacyPolicy() {
  const [htmlContent, setHtmlContent] = useState<string>("");

  useEffect(() => {
    // Fetch the static HTML file from the public directory
    fetch("/PrivacyPolicy.html")
      .then((response) => response.text())
      .then((html) => setHtmlContent(html))
      .catch((error) => console.error("Error loading privacy policy:", error));
  }, []);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}
    />
  );
}
